// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Raleway-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Merriweather-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Merriweather-Light.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --black: 0, 0, 0;
  --white: 255, 255, 255;
  --orange: 242, 117, 2;
  --orange-200: 248, 169, 52;
  --orange-300: 221, 115, 17;
  --red: 239, 0, 0;
  --red-200: 235, 24, 62;
  --red-300: 238, 56, 56;
  --yellow: 240, 217, 72;
  --brown: 191, 140, 93;
  --blue: 64, 148, 247;
  --blue-200: 56, 133, 243;
  --blue-500: 51, 102, 255;
  --green: 92, 177, 106;
  --violet: 169, 109, 244;
  --grey-100: 247, 248, 251;
  --grey-200: 228, 231, 236;
  --grey-300: 221, 223, 228;
  --grey-400: 190, 192, 198;
  --grey-500: 187, 187, 187;
  --grey-600: 102, 112, 133;
  --grey-650: 67, 73, 85;
  --grey-800: 35, 37, 44;
  --grey-810: 38, 40, 46;
  --grey-850: 25, 32, 56;
  --grey-900: 16, 24, 40;
  --blue-grey-300: 232, 233, 237;
  --merriweather: "Merriweather";
  --raleway: "Raleway";
}

@font-face {
  font-family: "Raleway";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Merriweather";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Merriweather";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 300;
}
html,
body {
  margin: 0;
  font-family: "Raleway", sans-serif, serif;
  font-size: 16px;
}

@media (min-width: 768px) {
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  ::-webkit-scrollbar-thumb {
    background: rgba(var(--grey-400));
    border-radius: 2px;
  }
}
@media (max-width: 768px) {
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-between-start {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.display-none {
  display: none;
  opacity: 0;
}

.w-100 {
  width: 100%;
}

.button {
  text-align: center;
  border-radius: 0.25rem;
  font-family: var(--raleway);
  height: 40px;
  padding: 0.5rem 1.125rem;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.625;
  color: rgba(var(--white));
  background-color: rgba(var(--orange));
  text-decoration: none;
  display: inline-block;
  border: none;
  cursor: pointer; /* Safari */
  transition-duration: 0.4s;
}
@media (max-width: 768px) {
  .button {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .button_small {
    width: auto;
  }
}
.button_disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.button_disabled.shadow:hover {
  box-shadow: none;
}
.button:not(.button_disabled):hover {
  background-color: rgba(var(--orange-300));
}

.shadow { /* Safari */
  transition-duration: 0.4s;
}
.shadow:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.line {
  height: 1px;
  background-color: rgba(var(--grey-100));
}
@media (max-width: 768px) {
  .line {
    background-color: rgba(var(--grey-200));
  }
}

a:active,
a:hover,
a {
  text-decoration: none;
}

.pointer {
  cursor: pointer;
}

.swiper-nav-button {
  transform: translate(0, -50%);
  position: absolute;
  top: 50%;
  z-index: 2;
  transition: opacity 300ms ease-in-out;
  opacity: 0;
  cursor: pointer;
}
@media (max-width: 768px) {
  .swiper-nav-button {
    display: none;
  }
}
.swiper-nav-button_next {
  right: 0;
}
.swiper-nav-button_prev {
  left: 0;
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes show2 {
  from {
    opacity: 0.6;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/variables.scss","webpack://./src/styles/index.scss","webpack://./src/styles/fonts.scss","webpack://./src/styles/common.scss"],"names":[],"mappings":"AAIA;EACE,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uBAAA;EAEA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EAEA,8BAAA;EAEA,8BAAA;EACA,oBAAA;ACNF;;AC9BA;EACE,sBAAA;EACA,+DAAA;ADiCF;AC9BA;EACE,2BAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;ADgCF;AC7BA;EACE,2BAAA;EACA,+DAAA;EACA,gBAAA;AD+BF;AE9CA;;EAEE,SAAA;EACA,yCAAA;EACA,eAAA;AFgDF;;AE7CA;EACE;IACE,UAAA;IACA,WAAA;EFgDF;EE7CA;IACE,iCAAA;IACA,kBAAA;EF+CF;AACF;AE5CA;EACE;IACE,QAAA;IACA,SAAA;EF8CF;AACF;AE3CA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AF6CF;;AE1CA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AF6CF;;AE1CA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AF6CF;;AE1CA;EACE,aAAA;EACA,UAAA;AF6CF;;AE1CA;EACE,WAAA;AF6CF;;AE1CA;EACE,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA,EACA,WAAA;EACA,yBAAA;AF6CF;AE3CE;EAlBF;IAmBI,WAAA;EF8CF;AACF;AE3CI;EADF;IAEI,WAAA;EF8CJ;AACF;AE3CE;EACE,YAAA;EACA,mBAAA;AF6CJ;AE3CI;EACE,gBAAA;AF6CN;AEzCE;EACE,yCAAA;AF2CJ;;AEvCA,UACE,WAAA;EACA,yBAAA;AF0CF;AExCE;EACE,4EAAA;AF0CJ;;AEtCA;EACE,WAAA;EACA,uCAAA;AFyCF;AEvCE;EAJF;IAKI,uCAAA;EF0CF;AACF;;AEvCA;;;EAGE,qBAAA;AF0CF;;AEvCA;EACE,eAAA;AF0CF;;AEvCA;EAEE,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,qCAAA;EACA,UAAA;EACA,eAAA;AF0CF;AExCE;EAVF;IAWI,aAAA;EF2CF;AACF;AEzCE;EACE,QAAA;AF2CJ;AExCE;EACE,OAAA;AF0CJ;;AEtCA;EACE;IACE,2BAAA;EFyCF;AACF;AEtCA;EACE;IACE,UAAA;EFwCF;EEtCA;IACE,UAAA;EFwCF;AACF;AErCA;EACE;IACE,YAAA;EFuCF;EErCA;IACE,UAAA;EFuCF;AACF","sourcesContent":["@function toRGB($color) {\n  @return red($color), green($color), blue($color);\n}\n\n:root {\n  --black: #{toRGB(#000000)};\n  --white: #{toRGB(#ffffff)};\n  --orange: #{toRGB(#f27502)};\n  --orange-200: #{toRGB(#f8a934)};\n  --orange-300: #{toRGB(#dd7311)};\n  --red: #{toRGB(#ef0000)};\n  --red-200: #{toRGB(#eb183e)};\n  --red-300: #{toRGB(#ee3838)};\n  --yellow: #{toRGB(#f0d948)};\n  --brown: #{toRGB(#bf8c5d)};\n  --blue: #{toRGB(#4094f7)};\n  --blue-200: #{toRGB(#3885f3)};\n  --blue-500: #{toRGB(#3366ff)};\n  --green: #{toRGB(#5cb16a)};\n  --violet: #{toRGB(#a96df4)};\n\n  --grey-100: #{toRGB(#f7f8fb)};\n  --grey-200: #{toRGB(#e4e7ec)};\n  --grey-300: #{toRGB(#dddfe4)};\n  --grey-400: #{toRGB(#bec0c6)};\n  --grey-500: #{toRGB(#bbbbbb)};\n  --grey-600: #{toRGB(#667085)};\n  --grey-650: #{toRGB(#434955)};\n  --grey-800: #{toRGB(#23252c)};\n  --grey-810: #{toRGB(#26282e)};\n  --grey-850: #{toRGB(#192038)};\n  --grey-900: #{toRGB(#101828)};\n\n  --blue-grey-300: #{toRGB(#e8e9ed)};\n\n  --merriweather: 'Merriweather';\n  --raleway: 'Raleway';\n}\n",":root {\n  --black: 0, 0, 0;\n  --white: 255, 255, 255;\n  --orange: 242, 117, 2;\n  --orange-200: 248, 169, 52;\n  --orange-300: 221, 115, 17;\n  --red: 239, 0, 0;\n  --red-200: 235, 24, 62;\n  --red-300: 238, 56, 56;\n  --yellow: 240, 217, 72;\n  --brown: 191, 140, 93;\n  --blue: 64, 148, 247;\n  --blue-200: 56, 133, 243;\n  --blue-500: 51, 102, 255;\n  --green: 92, 177, 106;\n  --violet: 169, 109, 244;\n  --grey-100: 247, 248, 251;\n  --grey-200: 228, 231, 236;\n  --grey-300: 221, 223, 228;\n  --grey-400: 190, 192, 198;\n  --grey-500: 187, 187, 187;\n  --grey-600: 102, 112, 133;\n  --grey-650: 67, 73, 85;\n  --grey-800: 35, 37, 44;\n  --grey-810: 38, 40, 46;\n  --grey-850: 25, 32, 56;\n  --grey-900: 16, 24, 40;\n  --blue-grey-300: 232, 233, 237;\n  --merriweather: \"Merriweather\";\n  --raleway: \"Raleway\";\n}\n\n@font-face {\n  font-family: \"Raleway\";\n  src: url(\"../fonts/Raleway-VariableFont_wght.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"Merriweather\";\n  src: url(\"../fonts/Merriweather-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n  font-style: normal;\n}\n@font-face {\n  font-family: \"Merriweather\";\n  src: url(\"../fonts/Merriweather-Light.ttf\") format(\"truetype\");\n  font-weight: 300;\n}\nhtml,\nbody {\n  margin: 0;\n  font-family: \"Raleway\", sans-serif, serif;\n  font-size: 16px;\n}\n\n@media (min-width: 768px) {\n  ::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: rgba(var(--grey-400));\n    border-radius: 2px;\n  }\n}\n@media (max-width: 768px) {\n  ::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n}\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flex-between-start {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.display-none {\n  display: none;\n  opacity: 0;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.button {\n  text-align: center;\n  border-radius: 0.25rem;\n  font-family: var(--raleway);\n  height: 40px;\n  padding: 0.5rem 1.125rem;\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 1.625;\n  color: rgba(var(--white));\n  background-color: rgba(var(--orange));\n  text-decoration: none;\n  display: inline-block;\n  border: none;\n  cursor: pointer;\n  -webkit-transition-duration: 0.4s; /* Safari */\n  transition-duration: 0.4s;\n}\n@media (max-width: 768px) {\n  .button {\n    width: 100%;\n  }\n}\n@media (max-width: 768px) {\n  .button_small {\n    width: auto;\n  }\n}\n.button_disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.button_disabled.shadow:hover {\n  box-shadow: none;\n}\n.button:not(.button_disabled):hover {\n  background-color: rgba(var(--orange-300));\n}\n\n.shadow {\n  -webkit-transition-duration: 0.4s; /* Safari */\n  transition-duration: 0.4s;\n}\n.shadow:hover {\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n.line {\n  height: 1px;\n  background-color: rgba(var(--grey-100));\n}\n@media (max-width: 768px) {\n  .line {\n    background-color: rgba(var(--grey-200));\n  }\n}\n\na:active,\na:hover,\na {\n  text-decoration: none;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.swiper-nav-button {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  transition: opacity 300ms ease-in-out;\n  opacity: 0;\n  cursor: pointer;\n}\n@media (max-width: 768px) {\n  .swiper-nav-button {\n    display: none;\n  }\n}\n.swiper-nav-button_next {\n  right: 0;\n}\n.swiper-nav-button_prev {\n  left: 0;\n}\n\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n@keyframes show {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes show2 {\n  from {\n    opacity: 0.6;\n  }\n  to {\n    opacity: 1;\n  }\n}","@font-face {\n  font-family: 'Raleway';\n  src: url('../fonts/Raleway-VariableFont_wght.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Merriweather';\n  src: url('../fonts/Merriweather-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Merriweather';\n  src: url('../fonts/Merriweather-Light.ttf') format('truetype');\n  font-weight: 300;\n}\n","html,\nbody {\n  margin: 0;\n  font-family: 'Raleway', sans-serif, serif;\n  font-size: 16px;\n}\n\n@media (min-width: 768px) {\n  ::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: rgba(var(--grey-400));\n    border-radius: 2px;\n  }\n}\n\n@media (max-width: 768px) {\n  ::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.flex-between-start {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.display-none {\n  display: none;\n  opacity: 0;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n.button {\n  text-align: center;\n  border-radius: 0.25rem;\n  font-family: var(--raleway);\n  height: 40px;\n  padding: 0.5rem 1.125rem;\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 1.625;\n  color: rgba(var(--white));\n  background-color: rgba(var(--orange));\n  text-decoration: none;\n  display: inline-block;\n  border: none;\n  cursor: pointer;\n  -webkit-transition-duration: 0.4s; /* Safari */\n  transition-duration: 0.4s;\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n\n  &_small {\n    @media (max-width: 768px) {\n      width: auto;\n    }\n  }\n\n  &_disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n\n    &.shadow:hover {\n      box-shadow: none;\n    }\n  }\n\n  &:not(.button_disabled):hover {\n    background-color: rgba(var(--orange-300));\n  }\n}\n\n.shadow {\n  -webkit-transition-duration: 0.4s; /* Safari */\n  transition-duration: 0.4s;\n\n  &:hover {\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);\n  }\n}\n\n.line {\n  height: 1px;\n  background-color: rgba(var(--grey-100));\n\n  @media (max-width: 768px) {\n    background-color: rgba(var(--grey-200));\n  }\n}\n\na:active,\na:hover,\na {\n  text-decoration: none;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.swiper-nav-button {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  position: absolute;\n  top: 50%;\n  z-index: 2;\n  transition: opacity 300ms ease-in-out;\n  opacity: 0;\n  cursor: pointer;\n\n  @media (max-width: 768px) {\n    display: none;\n  }\n\n  &_next {\n    right: 0;\n  }\n\n  &_prev {\n    left: 0;\n  }\n}\n\n@keyframes shimmer {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n@keyframes show {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes show2 {\n  from {\n    opacity: 0.6;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
